var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "197px",
    height: "221px",
    viewBox: "0 0 197 221",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stroke 2 Copy@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PPP---Desktop-May-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gradient-Curve-Copy",
    transform: "translate(-451.000000, -285.000000)",
    stroke: "#9D8B02",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("line", {
    x1: 448.3715,
    y1: 502.497,
    x2: 650.9055,
    y2: 288.515,
    id: "Stroke-2-Copy",
    transform: "translate(549.638500, 395.506000) rotate(-2.000000) translate(-549.638500, -395.506000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingSlash);
export default __webpack_public_path__ + "static/media/landing-slash.a51c5ccf2208bffcb60dc65574315bcf.svg";
export { ForwardRef as ReactComponent };